var React = require('react');

function Down (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M18 11L13 16L8 11","stroke":"#262626","strokeOpacity":"0.7","strokeWidth":"1.6","strokeLinecap":"round","strokeLinejoin":"round"}));
}

Down.defaultProps = {"width":"26","height":"26","viewBox":"0 0 26 26","fill":"none"};

module.exports = Down;

Down.default = Down;
